<template>
    <div>
        <IconComp
            icon="fa-cog"
            class="me-2"
        ></IconComp>
        {{ $tm('general.actions') }}
    </div>
</template>
<script setup lang="ts">
import { IconComp } from '@/components';
</script>
